import React from "react";

export const RightCarrot = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.74611 3.76067C7.55085 3.95593 7.55085 4.27251 7.74611 4.46777L13.2851 10.0068L7.74611 15.5458C7.55085 15.741 7.55085 16.0576 7.74611 16.2529L8.45322 16.96C8.64848 17.1553 8.96506 17.1553 9.16032 16.96L14.962 11.1583C14.9987 11.137 15.0333 11.1106 15.0647 11.0792L15.7718 10.3721C15.967 10.1769 15.967 9.86027 15.7718 9.66501L9.16032 3.05356C8.96506 2.8583 8.64848 2.8583 8.45322 3.05356L7.74611 3.76067Z"
      fill="#292A33"
    />
    <mask
      id="mask0_508_7934"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="2"
      width="9"
      height="16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74611 3.76067C7.55085 3.95593 7.55085 4.27251 7.74611 4.46777L13.2851 10.0068L7.74611 15.5458C7.55085 15.741 7.55085 16.0576 7.74611 16.2529L8.45322 16.96C8.64848 17.1553 8.96506 17.1553 9.16032 16.96L14.962 11.1583C14.9987 11.137 15.0333 11.1106 15.0647 11.0792L15.7718 10.3721C15.967 10.1769 15.967 9.86027 15.7718 9.66501L9.16032 3.05356C8.96506 2.8583 8.64848 2.8583 8.45322 3.05356L7.74611 3.76067Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_508_7934)">
      <path d="M0 0H20V20H0V0Z" fill="#292A33" />
    </g>
  </svg>
);

export const DownCarrot = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2461 7.17503C16.0508 6.97977 15.7343 6.97977 15.539 7.17503L10 12.714L4.461 7.17503C4.26574 6.97977 3.94915 6.97977 3.75389 7.17503L3.04678 7.88214C2.85152 8.0774 2.85152 8.39399 3.04678 8.58925L9.65823 15.2007C9.85349 15.396 10.1701 15.396 10.3653 15.2007L11.0724 14.4936C11.1039 14.4622 11.1302 14.4276 11.1515 14.3909L16.9532 8.58925C17.1485 8.39399 17.1485 8.0774 16.9532 7.88214L16.2461 7.17503Z"
      fill="#292A33"
    />
    <mask
      id="mask0_510_8551"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="7"
      width="16"
      height="9"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2461 7.17503C16.0508 6.97977 15.7343 6.97977 15.539 7.17503L10 12.714L4.461 7.17503C4.26574 6.97977 3.94915 6.97977 3.75389 7.17503L3.04678 7.88214C2.85152 8.0774 2.85152 8.39399 3.04678 8.58925L9.65823 15.2007C9.85349 15.396 10.1701 15.396 10.3653 15.2007L11.0724 14.4936C11.1039 14.4622 11.1302 14.4276 11.1515 14.3909L16.9532 8.58925C17.1485 8.39399 17.1485 8.0774 16.9532 7.88214L16.2461 7.17503Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_510_8551)">
      <path d="M0 0H18V18H0V0Z" fill="#292A33" />
    </g>
  </svg>
);
